import {Injectable} from '@angular/core';
import {LocalStorageService} from './main/local-storage.service';
import {STORAGE_KEY_USER} from './constant-key';
import {User} from '../../models/user/user.model';

@Injectable()
export class UserStorageService {

    public constructor(private storage: LocalStorageService) {
    }

    /**
     * @param {User} user
     */
    public set(user: User): void {
        this.storage.set(STORAGE_KEY_USER, user);
    }

    /**
     * @returns {User}
     */
    public get(): User {
        return this.storage.get(STORAGE_KEY_USER) as User;
    }

    public remove(): void {
        this.storage.remove(STORAGE_KEY_USER);
    }
}



// WEBPACK FOOTER //
// ./src/shared/services/storage/user-storage.service.ts